import React from 'react';
import './footer.css';

//  const Footer: React.FC = () => {
//     return (
//       <div className="footer">
//             <p>
//          Designed & developed by Example Studios
//             </p>
//       </div>
//     );
//  };

//  export default Footer;
interface FooterProps {
  text: string;
  }

  const Footer: React.FC<FooterProps> = ({ text }) => {
  return (
  <div className="footer">
      <p>{text}</p>
  </div>
  );
  };

  export default Footer;